import { render, staticRenderFns } from "./personCard.vue?vue&type=template&id=7e3e19fc&scoped=true&"
import script from "./personCard.vue?vue&type=script&lang=js&"
export * from "./personCard.vue?vue&type=script&lang=js&"
import style0 from "./personCard.vue?vue&type=style&index=0&id=7e3e19fc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e3e19fc",
  null
  
)

export default component.exports